import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import MiFileUpload from '@/components/mi-file-upload/MiFileUpload';
import { addClass, removeClass } from '@/support/Html';
import { Media, MediaTypeEnum } from '@/models/Media';

@Component<UploadMediaDialog>({})
export default class UploadMediaDialog extends Vue {

  @Prop({ default: '' })
  protected mediaId!: string;

  @Prop({ default: MediaTypeEnum.PURCHASE_ORDER })
  protected mediaType!: MediaTypeEnum;

  protected isLoading: boolean = false;
  protected activeStepper: boolean = true;
  protected currentStep: number = 1;

  protected acceptedFileTypes = [
    'application/msword',
    'application/pdf',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/x-bzip',
    'application/x-bzip2',
    'application/zip',
    'image/bmp',
    'image/gif',
    'image/jpeg',
    'image/jpg',
    'image/svg+xml',
    'msg',
    'oft',
    'pdf',
    'text/csv',
    'text/plain',
  ];
  protected selectedFile: File | null = null;
  protected uploadResponse: object | null = null;

  protected uploadedFile: string = '';

  protected uploadComponent: MiFileUpload | null = null;

  public mounted(): void {
    const pageHtml = document.querySelectorAll('html')[0];
    addClass(pageHtml, 'overflow-y-hidden');
  }

  protected goToStep(step: number) {
    if (this.currentStep < step || !this.activeStepper) {
      return;
    }

    this.currentStep = step;
  }

  protected close() {
    this.$emit('input', false);
    this.currentStep = 1;
    this.clear();
    const pageHtml = document.querySelectorAll('html')[0];
    removeClass(pageHtml, 'overflow-y-hidden');
  }

  protected clear() {
    this.selectedFile = null;
  }

  protected handleItemDropped(file: File) {
    if(!file) {
      return;
    }

    this.selectedFile = file;
    this.uploadComponent = this.$refs.fileUpload as MiFileUpload;
    this.uploadComponent.uploaded();
  }

  protected create() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.currentStep = 2;

    const payload: Partial<Media> = {
      id: this.mediaId,
      type: this.mediaType,
      image: this.selectedFile
        ? this.selectedFile
        : undefined,
    };

    new Media()
      .create(payload)
      .then((response: AxiosResponse) => {
        this.isLoading = false;
        if (response) {
          this.uploadResponse = response;
        }
        this.$emit('uploaded');
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.isLoading = false;
        this.currentStep = 1;
        if (this.uploadComponent) {
          this.uploadComponent.reset()
        }
      })
  }
}
